import { RequestPagination } from "src/utils/types"
import { SubCaste } from "../../entities/subCaste"
import { ApiRequester } from "../ApiRequester"

interface RequestDataShape {
	id?: string
	code?: string
	pagination?: RequestPagination
}

export async function subCasteListApi(payload: RequestDataShape, token?: null | string) {
	const endpoint = "/subCaste/list/v1"
	const requester = new ApiRequester<RequestDataShape, SubCaste[]>(endpoint)
	return await requester.sendRequest(payload, token)
}
